var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-xl g-0 g-lg-2" }, [
    _c("div", { staticClass: "row h-100 g-0 g-lg-2" }, [
      _c("div", { staticClass: "col h-100" }, [
        _c(
          "div",
          {
            staticClass: "header-small d-flex row",
            style: { backgroundImage: `url(${this.headerbg}) !important` },
          },
          [
            _c(
              "div",
              { staticClass: "col-11 col-xl-5 col-lg-6 h-100 d-lg-flex" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "promo-form ic-form header-form itinerary-form mt-auto py-5 flex-grow-1 pb-0 pb-lg-5",
                  },
                  [
                    _c(
                      "form",
                      {
                        staticClass:
                          "form-medium jsFormHelpersConnections-Contener jsStationAlerts",
                        attrs: { name: "searchTrain", method: "get" },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "typehead-container" },
                          [
                            _vm._t("lowcy-from", function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "start mb-3 no-border",
                                    attrs: {
                                      role: "combobox",
                                      "aria-haspopup": "listbox",
                                      "aria-expanded": "false",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c("input", {
                                        staticClass:
                                          "jsStationTypeaheadItem jsCzwartkomaniaNearestStationItem form-control",
                                        attrs: {
                                          type: "search",
                                          id: "stname-0",
                                          name: "stname[0]",
                                          "aria-label":
                                            "Stacja odjazdu. Rozpocznij wpisywanie a po trzech wprowadzonych znakach wyniki wyszukiwania pojawią się automatycznie. Aby przejść na wyniki wyszukiwania naciśnij strzałkę w dół",
                                          placeholder: "np. Warszawa Centralna",
                                          autocomplete: "off",
                                          role: "searchbox",
                                          "aria-multiline": "false",
                                          "aria-autocomplete": "list",
                                          "data-params":
                                            '{ "from":1 ,"czwartkomania":1 }',
                                        },
                                        domProps: { value: _vm.stname0 },
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "jsTypeaheadItem-Value",
                                        attrs: {
                                          type: "hidden",
                                          name: "stid[0]",
                                        },
                                        domProps: { value: _vm.stid0 },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "input-group-append" },
                                        [
                                          _vm._v(
                                            "\n                                  SKĄD\n                            "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "switch d-flex h-100 align-items-center d-none",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.reverse.apply(null, arguments)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi bi-arrow-down-up" })]
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._t("lowcy-to", function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "end no-border",
                                attrs: {
                                  role: "combobox",
                                  "aria-haspopup": "listbox",
                                  "aria-expanded": "false",
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    staticClass:
                                      "jsStationTypeaheadItem form-control",
                                    attrs: {
                                      type: "search",
                                      id: "stname-1",
                                      name: "stname[1]",
                                      "aria-label":
                                        "Stacja przyjazdu. Rozpocznij wpisywanie a po trzech wprowadzonych znakach wyniki wyszukiwania pojawią się automatycznie. Aby przejść na wyniki wyszukiwania naciśnij strzałkę w dół",
                                      placeholder: "np. Szczecin Główny",
                                      autocomplete: "off",
                                      role: "searchbox",
                                      "aria-multiline": "false",
                                      "aria-autocomplete": "list",
                                      "data-params":
                                        '{ "to":1 ,"czwartkomania":1 }',
                                    },
                                    domProps: { value: _vm.stname1 },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "jsTypeaheadItem-Value",
                                    attrs: { type: "hidden", name: "stid[1]" },
                                    domProps: { value: _vm.stid1 },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "input-group-append" },
                                    [
                                      _vm._v(
                                        "\n                                  DOKĄD\n                            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning mt-3",
                            attrs: { type: "submit" },
                          },
                          [_vm._v("Szukaj")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", id: "date", name: "date" },
                          domProps: { value: _vm.date },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "jsVariable-HafasPage",
                          attrs: {
                            type: "hidden",
                            name: "hafasPage",
                            value: "0",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "jsVariable-HafasSort",
                          attrs: {
                            type: "hidden",
                            name: "hafasSort",
                            value: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "jsVariable-HafasSort",
                          attrs: { type: "hidden", name: "search", value: "1" },
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "h3" }, [
      _vm._v("\n                  Łowcy "),
      _c("strong", [_vm._v("Super Promo!")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }